(function() { window.GUID_0f8bc919_1471_4a33_958b_0189b834659c = { getGuid: function() { return "0f8bc919-1471-4a33-958b-0189b834659c"; } }; })();
var CS;
(function (CS) {
    var Views;
    (function (Views) {
        class BracketView extends Views.ViewBase {
            constructor() {
                super(...arguments);
                this.minimalUIMode = null;
                this.popup = null;
            }
            OnDispose() {
                this.$Container.find(".section-bottom").off("click.bottom", "button");
                if (CS.Nav.CurrentSource != CS.Nav.Source.Refresh) {
                    CS.Ads.ShowFullscreen();
                }
                CS.DOM.$win.off("orientationchange.bracket resize.bracket");
            }
            updateUI() {
                let gz = CS.Controls.GetInstance(CS.Controls.DragZoom, $("#dragzoom-bracket-main"));
                const { minimalUIMode } = this;
                const { IsMobileDevice, IsTouchScreenDevice, IsLandscapeOrientation } = CS.CommonData.Current;
                const shouldUseMinimalUI = IsTouchScreenDevice && IsMobileDevice && IsLandscapeOrientation;
                const $topbarcontent = CS.DOM.$body.find(".topbar");
                const $topbarCenter = CS.DOM.$topBar.find("#top-bar-center");
                const $topbarButtons = CS.DOM.$topBar
                    .find(".topbar__btn")
                    .filter(":not(#button-back)");
                if (minimalUIMode != false) {
                    if (this.popup != null) {
                        this.popup.Close();
                    }
                }
                if (shouldUseMinimalUI) {
                    $topbarcontent.css({
                        "font-size": "0.75em",
                    });
                    $(".start-date").css({
                        display: "none",
                    });
                    CS.DOM.$sectionBottom.css({
                        "font-size": "0.75em",
                        width: "auto",
                        "margin-bottom": "0.5em",
                        "margin-right": "0.5em",
                        right: "0",
                        "min-width": "100px",
                        "border-radius": "0.5em",
                        "box-shadow": "1px 1px 10px rgb(0 0 0 / 75%)",
                    });
                    CS.DOM.$sectionBottom.find(".button").css({
                        padding: "0.5em 1em",
                    });
                    $topbarCenter.css({
                        display: "none",
                    });
                    $(".section-bottom").last();
                    const $currentMiddle = $(".section-middle").last();
                    $currentMiddle.css({
                        top: $topbarcontent.outerHeight(),
                        bottom: 0,
                    });
                    let $dbm = $("#dragzoom-bracket-main");
                    let $scrollPart = $dbm.find(".scrollable-part");
                    $scrollPart.height($dbm.outerHeight());
                    $("#brackets-picker").insertBefore(".notification-ico");
                    this.minimalUIMode = true;
                }
                else if (!shouldUseMinimalUI) {
                    $("#brackets-picker").appendTo("#section-sub-top > .section-inner-subtop-content");
                    $topbarcontent.css({
                        "font-size": "",
                    });
                    CS.DOM.$topBar.find(".start-date").show();
                    CS.DOM.$sectionBottom.css({
                        "font-size": "",
                        width: "",
                        "margin-bottom": "",
                        "margin-right": "",
                        right: "",
                        "min-width": "",
                        "border-radius": "",
                        "box-shadow": "",
                    });
                    CS.DOM.$sectionBottom.find(".button").css({
                        padding: "",
                    });
                    $topbarCenter.css({
                        display: "",
                    });
                    const $currentMiddle = $(".section-middle").last();
                    $currentMiddle.css({
                        top: CS.Views.MasterPage.TopHeight,
                        bottom: CS.DOM.$sectionBottom.outerHeight(),
                    });
                    this.minimalUIMode = false;
                }
            }
            OnBindEvents() {
                CS.Ads.PreLoadAd();
                CS.DOM.$win.offon("orientationchange.bracket resize.bracket", () => {
                    CS.Lag("uichangebracket", 150, () => {
                        this.updateUI();
                    });
                });
                CS.DOM.$body.offon("click.bracketBottomMainMenu", "#button-bracket-bottom-main-menu", (e) => {
                    const $button = $(e.currentTarget);
                    const htmlData = $button.data("html");
                    if (htmlData != null) {
                        const { popopUrl } = htmlData;
                        if (popopUrl != null) {
                            CS.Controls.Popup.ShowAjaxModal(popopUrl, {}, ({ popup, isPopup }) => {
                                if (!isPopup) {
                                    return;
                                }
                                this.popup = popup;
                                if (popup != null && popup.$Control.length) {
                                    const isMainMenuPopup = popup.$Control.find(".main-menu-content").length > 0;
                                    if (isMainMenuPopup) {
                                        const $popupContent = popup.$Control.find(".popup-content");
                                        if ($popupContent.length) {
                                            $popupContent.css({ overflow: "unset" });
                                            //$popupContent.css({ opacity: 0 });
                                            CS.Lag("popup-content-opacity", 500, () => {
                                                //$popupContent.scrollTop(0);
                                                //$popupContent.animate({ opacity: 1 }, 100);
                                                $popupContent.css({ overflow: "" });
                                            });
                                        }
                                        const $masterAdminItem = popup.$Control.find("#main-menu-master-admin-item-header23432");
                                        if ($masterAdminItem.length) {
                                            $masterAdminItem.offon("click.hideMasterAdminsItems", (e) => {
                                                popup.$Control
                                                    .find(".main-menu-content__section.master-admin")
                                                    .hide();
                                            });
                                        }
                                        popup.$Control.offon("click.mainMenuItemClickk", ".item:not(a)", (e) => {
                                            const $item = $(e.currentTarget);
                                            const popupUrl = $item.data("popup-url");
                                            if (popupUrl != null) {
                                                CS.Controls.Popup.ShowAjaxModal(popupUrl, {}, () => { }, () => { }, null, false);
                                            }
                                        });
                                    }
                                }
                            }, ({ popup }) => { }, true);
                        }
                    }
                });
            }
            OnDiscoveringDOM() {
                let me = this;
                CS.DivisionsPicker.ShowDrawerIfNotDivisionSelected("brackets-picker");
                CS.DivisionsPicker.OnItemClick("brackets-picker", (divisionId, customUrl, divisionsPicker) => {
                    CS.Nav.Go(customUrl, null, CS.Nav.Source.Standard, divisionsPicker.replaceUrlOnClick);
                });
                CS.Controls.DragZoom.Events.Scrolled({
                    selector: ".drag-zoom",
                    callback: (dragzoom, e) => {
                    },
                });
                CS.Controls.DragZoom.Events.AfterUpdateTransform({
                    selector: ".drag-zoom",
                    callback: (dragzoom, ev) => {
                        // Center header collapse chevron in middle of screen
                        // Il n'y a plus de chevrons
                        //let chevrons = $('.text-hide, .text-show');
                        //chevrons.each((i, e) => {
                        //    let chevron = $(e);
                        //    let row = chevron.closest('.sections-headers');
                        //    if (row.width() > dragzoom.$ScrollablePart.width() / ev.data.Scale) {
                        //        let centerHeaderX = ((dragzoom.$ScrollablePart.width() / ev.data.Scale) - row.width()) / 2;
                        //        let chevronOffsetX = centerHeaderX - ev.data.ScaledOffsetX;
                        //        chevron[0].style.transform = 'translate3d(' + chevronOffsetX + 'px,0px,0px)';
                        //    } else {
                        //        chevron[0].style.transform = null;
                        //    }
                        //});
                        // Sticky headers
                        let stickies = $(".sections-headers.sticky");
                        //// resize header text if zoomed enough
                        //// Marche pas bien en mobile
                        //let match = me.$Container.find('.bracket__match-opponent:first');
                        ////let small = (match[0].clientHeight * ev.data.Scale) > 20;
                        //let size = 1 - 0.56 * -0.67 + ev.data.Scale * -0.67;
                        //let fontSize = Math.min(1, size);
                        //let small = size < 1;
                        ////let smallest = (match[0].clientHeight * ev.data.Scale) > 28;
                        //stickies.toggleClass('smaller-font', small);
                        ////stickies.toggleClass('smallest-font', smallest);
                        //if (me.newSticky) {
                        //    me.newSticky.toggleClass('smaller-font', small);
                        //    //me.newSticky.toggleClass('smallest-font', smallest);
                        //}
                        //$(":root").css({ "--size": fontSize + "em" });
                        let hasSticky = false;
                        let offsetY = ev.data.ScaledOffsetY;
                        for (var i = 0; i < stickies.length; i++) {
                            let sticky = $(stickies[i]);
                            let stickyPos = sticky.offset();
                            let scrollableOffset = dragzoom.$ScrollablePart.offset();
                            let stickyOffsetY = stickyPos.top - scrollableOffset.top;
                            if (stickyOffsetY < 0) {
                                if (i == 0 && stickies.length > 1) {
                                    let nextSticky = $(stickies[1]);
                                    let nextStickyPos = nextSticky.offset();
                                    let distWithNextSticky = (nextStickyPos.top -
                                        (stickyPos.top +
                                            ev.data.OffsetY +
                                            sticky.height() * ev.data.Scale)) /
                                        ev.data.Scale;
                                    let maxDist = 250; // * zoomFactor;
                                    if (distWithNextSticky < maxDist) {
                                        let nextStickyOffset = maxDist - distWithNextSticky;
                                        if (nextStickyOffset > sticky.height()) {
                                            //Il est maintenant caché au complet
                                            if (me.newSticky &&
                                                nextStickyPos.top - scrollableOffset.top > 0) {
                                                me.newSticky.remove();
                                                me.newSticky = null;
                                            }
                                            continue;
                                        }
                                        offsetY += nextStickyOffset;
                                    }
                                }
                                if (!me.newSticky) {
                                    me.newSticky = sticky.clone(true, true);
                                    me.newSticky.addClass("new-sticky");
                                    me.newSticky.removeClass("sticky");
                                    me.newSticky.insertAfter(sticky);
                                }
                                me.newSticky[0].style.transform =
                                    "translate(0px," + -offsetY + "px)";
                                me.newSticky[0].style.scrollMarginTop = -offsetY + "px"; //Hack pour HtmlToCanvas
                                hasSticky = true;
                            }
                            else if (!hasSticky && me.newSticky) {
                                me.newSticky.remove();
                                me.newSticky = null;
                            }
                        }
                    },
                });
                let $bottom = this.$Container.find(".section-bottom");
                $bottom.offon("click.bottom", "button", function (e) {
                    var _a;
                    let $dragZoom = me.$Container.find(".drag-zoom");
                    let dragZoom = CS.Controls.GetInstance(CS.Controls.DragZoom, $dragZoom);
                    let $button = $(this);
                    let id = $button.attr("id");
                    if (id == "button-zoom-in") {
                        dragZoom.ScaleUp();
                    }
                    else if (id == "button-zoom-out") {
                        dragZoom.ScaleDown();
                    }
                    else if (id == "button-refresh") {
                        var button = CS.Controls.GetInstance(CS.Controls.Button, $button);
                        if ((_a = button === null || button === void 0 ? void 0 : button.extraData) === null || _a === void 0 ? void 0 : _a.refreshUrl) {
                            CS.Ajax.Get(button.extraData.refreshUrl, null, function (response) {
                                let bracket = CS.Controls.GetInstance(CS.Controls.Bracket, me.$Container.find("#bracket-main"));
                                if (bracket) {
                                    bracket.ReplaceContent(response);
                                }
                                else {
                                    let bracketrrb = CS.Controls.GetInstance(CS.Controls.RRB, me.$Container.find("#rrb-chart-main"));
                                    if (bracketrrb) {
                                        bracketrrb.ReplaceContent(response);
                                    }
                                    else {
                                        console.warn("bracket is undefined, cannot refresh");
                                    }
                                }
                            });
                        }
                    }
                    else if (id == "button-home") {
                    }
                });
                let $buttonMatchDetails = this.$Container.find("#button-match-details");
                let $buttonMatchDetailsHtml;
                if ($buttonMatchDetails.length) {
                    $buttonMatchDetailsHtml = $buttonMatchDetails[0];
                }
                let matchDetailsUrl = $("#match-details-url").val();
                let overrideShouldTriggerPopup = null;
                let popupIsOpen = false;
                let outerHeight = 0;
                CS.Controls.Bracket.Events.MatchSelectionChanged({
                    selector: "#bracket-main",
                    callback: (bracket, e) => {
                        let url = "";
                        if (e.data.matchId) {
                            url = matchDetailsUrl.replace("matchidreplacement", e.data.matchId.toString());
                        }
                        if ($buttonMatchDetails.length) {
                            if (e.data.matchId) {
                                $buttonMatchDetails.addClass("enabled");
                                $buttonMatchDetailsHtml.href = url;
                            }
                            else {
                                $buttonMatchDetails.removeClass("enabled");
                                $buttonMatchDetailsHtml.href = "#";
                            }
                        }
                        try {
                            if (overrideShouldTriggerPopup == false) {
                                console.log("overrideShouldTriggerPopup == false");
                                return;
                            }
                            const bracketDrawerUrl = CS.Url.CSUrl("BracketDrawer");
                            const { matchId, matchNumber, opponentId, $selectedEncounter, isFake, preventBracketDrawer, } = e.data;
                            let isLive = false;
                            if ($selectedEncounter) {
                                isLive = $selectedEncounter.find("div").hasClass("live");
                            }
                            let shouldTriggerPopup = matchId != null && isFake != true && preventBracketDrawer != true;
                            const data = {
                                selectedMatchId: matchId,
                                matchNumber,
                                homeEntityBaseId: "",
                                awayEntityBaseId: "",
                                highlightedEntityBaseId: opponentId,
                                homeIsWinner: false,
                                awayIsWinner: false,
                                isLive,
                                homeScore: "",
                                awayScore: "",
                                winnerMatchNumber: null,
                                loserMatchNumber: null,
                                flowBlockIdDest: null,
                                flowBlockIdSourceAway: null,
                                flowBlockIdSourceHome: null,
                                drawPositionSourceHome: null,
                                drawPositionSourceAway: null,
                                homeFromMatchNumber: null,
                                homeFromWinner: null,
                                awayFromMatchNumber: null,
                                awayFromWinner: null,
                                shouldDisplayKeepBracketDrawerOpenCheckbox: true,
                                keepBracketDrawerOpenCheckboxDefaultValue: CS.Cookie.GetCookie(CS.Cookie.Names.UI.ShouldKeepBracketDrawerOpen) === "1",
                            };
                            if (shouldTriggerPopup) {
                                if ($selectedEncounter.length) {
                                    $(`.wof[data-mn="${matchNumber}"]`).each((_, el) => {
                                        const $winnerOf = $(el);
                                        const winnerFromMatchNumber = $winnerOf.attr("data-dest");
                                        if (winnerFromMatchNumber != null) {
                                            const parsed = Number(winnerFromMatchNumber);
                                            if (!isNaN(parsed)) {
                                                const side = $winnerOf.attr("data-side");
                                                if (side === "home") {
                                                    data.homeFromMatchNumber = parsed;
                                                    data.homeFromWinner = true;
                                                }
                                                else if (side === "away") {
                                                    data.awayFromMatchNumber = parsed;
                                                    data.awayFromWinner = true;
                                                }
                                            }
                                        }
                                    });
                                    $(`.lof[data-mn="${matchNumber}"]`).each((_, el) => {
                                        const $loserOf = $(el);
                                        const loserFromMatchNumber = $loserOf.attr("data-dest");
                                        if (loserFromMatchNumber != null) {
                                            const parsed = Number(loserFromMatchNumber);
                                            if (!isNaN(parsed)) {
                                                const side = $loserOf.attr("data-side");
                                                if (side === "home") {
                                                    data.homeFromMatchNumber = parsed;
                                                    data.homeFromWinner = false;
                                                }
                                                else if (side === "away") {
                                                    data.awayFromMatchNumber = parsed;
                                                    data.awayFromWinner = false;
                                                }
                                            }
                                        }
                                    });
                                    const $winnerTo = $selectedEncounter.find(".wto").first();
                                    if ($winnerTo.length) {
                                        const winnerMatchNumber = $winnerTo.attr("data-winner-match-number");
                                        if (winnerMatchNumber != null) {
                                            const winnerMatchNumberParsed = Number(winnerMatchNumber);
                                            if (!isNaN(winnerMatchNumberParsed)) {
                                                data.winnerMatchNumber = winnerMatchNumberParsed;
                                            }
                                        }
                                    }
                                    const $loserTo = $selectedEncounter.find(".lto").first();
                                    if ($loserTo.length) {
                                        const loserMatchNumber = $loserTo.attr("data-loser-match-number");
                                        if (loserMatchNumber != null) {
                                            const loserMatchNumberParsed = Number(loserMatchNumber);
                                            if (!isNaN(loserMatchNumberParsed)) {
                                                data.loserMatchNumber = loserMatchNumberParsed;
                                            }
                                        }
                                    }
                                    const $opponents = $selectedEncounter.find(".bracket__match-opponent");
                                    const opponentIds = [];
                                    $opponents.each((index, opponent) => {
                                        var _a, _b;
                                        const $opponent = $(opponent);
                                        if (index === 0) {
                                            data.flowBlockIdSourceHome = $opponent.attr("data-fbis");
                                            data.drawPositionSourceHome = $opponent.attr("data-drawsource");
                                        }
                                        else if (index === 1) {
                                            data.flowBlockIdSourceAway = $opponent.attr("data-fbis");
                                            data.drawPositionSourceAway = $opponent.attr("data-drawsource");
                                        }
                                        data.flowBlockIdDest = $opponent.attr("data-fbid");
                                        const dataEbId = $opponent.attr("data-eid");
                                        if (dataEbId != null) {
                                            opponentIds.push(dataEbId);
                                        }
                                        if (index === 0) {
                                            data.homeIsWinner = $opponent.hasClass("win");
                                            data.homeScore = ((_a = $opponent.find(".scor .in").text()) !== null && _a !== void 0 ? _a : "").trim();
                                        }
                                        else if (index === 1) {
                                            data.awayIsWinner = $opponent.hasClass("win");
                                            data.awayScore = ((_b = $opponent.find(".scor .in").text()) !== null && _b !== void 0 ? _b : "").trim();
                                        }
                                    });
                                    if (opponentIds.length <= 2) {
                                        data.homeEntityBaseId =
                                            (opponentIds === null || opponentIds === void 0 ? void 0 : opponentIds.length) > 0 ? opponentIds[0] : "";
                                        data.awayEntityBaseId =
                                            (opponentIds === null || opponentIds === void 0 ? void 0 : opponentIds.length) > 1 ? opponentIds[1] : "";
                                        //shouldTriggerPopup =
                                        //  !Helper.isNullOrWhiteSpace(data.homeEntityBaseId) &&
                                        //  !Helper.isNullOrWhiteSpace(data.awayEntityBaseId);
                                    }
                                    else {
                                        shouldTriggerPopup = false;
                                    }
                                }
                                else {
                                    shouldTriggerPopup = false;
                                }
                            }
                            ;
                            if (shouldTriggerPopup) {
                                $("#checkbox-cs-bracket-drawer-should-keep-open").remove();
                                CS.Controls.Popup.ShowAjaxModal(bracketDrawerUrl, data, ({ popup, isPopup }) => {
                                    if (!isPopup) {
                                        return;
                                    }
                                    if (CS.Cookie.GetCookie(CS.Cookie.Names.UI.ShouldKeepBracketDrawerOpen) === "1") {
                                        popup.$Control.addClass("popup--no-overlay");
                                    }
                                    CS.Lag("bracketdraweropened", 100, () => {
                                        outerHeight = 0;
                                        if (popup.$PopupInner) {
                                            outerHeight = popup.$PopupInner.outerHeight();
                                        }
                                        $("#bracket-main").css("margin-bottom", outerHeight);
                                    });
                                    popupIsOpen = true;
                                    const triggerClickOnMatchNumberTarget = ($matchNumberTarget) => {
                                        bracket.isDragging = false;
                                        $matchNumberTarget.trigger("click");
                                    };
                                    popup.$Control.offon("click.bracketdrawerwtotrigger", ".wto-trigger", (e) => {
                                        const $trigger = $(e.currentTarget);
                                        const matchNumber = $trigger.attr("data-match-number");
                                        if (!matchNumber)
                                            return;
                                        const $matchNumberTarget = $("#chart-main").find(`.bracket__match[data-mn="${data.matchNumber}"] .wto[data-winner-match-number="${matchNumber}"]`);
                                        if (!$matchNumberTarget.length)
                                            return;
                                        triggerClickOnMatchNumberTarget($matchNumberTarget);
                                    });
                                    popup.$Control.offon("click.bracketdrawerltotrigger", ".lto-trigger", (e) => {
                                        const $trigger = $(e.currentTarget);
                                        const matchNumber = $trigger.attr("data-match-number");
                                        if (!matchNumber) {
                                            console.warn("No match number found for lto-trigger click event");
                                            return;
                                        }
                                        const $matchNumberTarget = $("#chart-main").find(`.bracket__match[data-mn="${data.matchNumber}"] .lto[data-loser-match-number="${matchNumber}"]`);
                                        if (!$matchNumberTarget.length) {
                                            console.warn("No match number target found for lto-trigger click event");
                                            return;
                                        }
                                        triggerClickOnMatchNumberTarget($matchNumberTarget);
                                    });
                                    popup.$Control.offon("click.bracketdrawerwoftrigger", ".wof-trigger", (e) => {
                                        const $trigger = $(e.currentTarget);
                                        const matchNumber = $trigger.attr("data-match-number");
                                        console.log("matchNumber", matchNumber);
                                        if (!matchNumber) {
                                            console.warn("No match number found for wof-trigger click event");
                                            return;
                                        }
                                        const $matchNumberTarget = $("#chart-main").find(`.wof[data-dest="${matchNumber}"]`);
                                        if (!$matchNumberTarget.length) {
                                            console.warn("No match number target found for wof-trigger click event");
                                            return;
                                        }
                                        triggerClickOnMatchNumberTarget($matchNumberTarget);
                                    });
                                    popup.$Control.offon("click.bracketdrawerloftrigger", ".lof-trigger", (e) => {
                                        const $trigger = $(e.currentTarget);
                                        const matchNumber = $trigger.attr("data-match-number");
                                        if (!matchNumber) {
                                            console.warn("No match number found for lof-trigger click event");
                                            return;
                                        }
                                        const $matchNumberTarget = $("#chart-main").find(`.lof[data-dest="${matchNumber}"]`);
                                        if (!$matchNumberTarget.length) {
                                            console.warn("No match number target found for lof-trigger click event");
                                            return;
                                        }
                                        triggerClickOnMatchNumberTarget($matchNumberTarget);
                                    });
                                    popup.$Control.offon("click.bracketdraweropponent", ".opponent", (e) => {
                                        try {
                                            const $opponent = $(e.currentTarget);
                                            const $otherOpponent = $opponent
                                                .closest(".opponents")
                                                .find(".opponent")
                                                .not($opponent);
                                            if (!$otherOpponent.length)
                                                return;
                                            const isHighlighted = $opponent.hasClass(".opponent--highlighted");
                                            const matchId = $opponent.attr("data-matchid");
                                            const opponentId = $opponent.attr("data-opponentid");
                                            const $encounter = $("#chart-main").find(`.bracket__match[data-ei="${matchId}"]`);
                                            if (!$encounter.length)
                                                return;
                                            const $encounterOpponents = $encounter.find(".bracket__match-opponent");
                                            if (!$encounterOpponents.length ||
                                                $encounterOpponents.length !== 2)
                                                return;
                                            const $matchingEncounterOpponent = $encounter.find(`.bracket__match-opponent[data-eid="${opponentId}"]`);
                                            const $otherEncounterOpponent = $encounterOpponents.not($matchingEncounterOpponent);
                                            overrideShouldTriggerPopup = false;
                                            if (isHighlighted) {
                                                $opponent.removeClass("opponent--highlighted");
                                                $otherOpponent.addClass("opponent--highlighted");
                                                $otherEncounterOpponent.trigger("click");
                                            }
                                            else {
                                                $opponent.addClass("opponent--highlighted");
                                                $otherOpponent.removeClass("opponent--highlighted");
                                                $matchingEncounterOpponent.trigger("click");
                                            }
                                        }
                                        catch (error) {
                                            console.error(error);
                                        }
                                        finally {
                                            overrideShouldTriggerPopup = null;
                                        }
                                    });
                                    CS.Controls.CheckBox.Events.CheckboxValueChanged({
                                        selector: CS.DOM.$body,
                                        childSelector: ".bracket-drawer .keep-open-checkbox .checkbox",
                                        callback: (checkbox, e) => {
                                            const shouldKeepOpen = e.data.value == "true";
                                            CS.Cookie.SetCookie(CS.Cookie.Names.UI.ShouldKeepBracketDrawerOpen, shouldKeepOpen ? "1" : "0");
                                            if (shouldKeepOpen) {
                                                popup.$Control.addClass("popup--no-overlay");
                                            }
                                            else {
                                                popup.$Control.removeClass("popup--no-overlay");
                                            }
                                        },
                                    });
                                }, ({ popup }) => {
                                    popupIsOpen = false;
                                    $("#bracket-main").css("margin-bottom", "");
                                }, true, true, true);
                            }
                            else if (overrideShouldTriggerPopup == null &&
                                matchId == null &&
                                popupIsOpen &&
                                CS.Cookie.GetCookie(CS.Cookie.Names.UI.ShouldKeepBracketDrawerOpen) !== "1") {
                                const $bracketDrawer = $(`[id*="popup-cs-bracket-drawer"]`);
                                if ($bracketDrawer.length) {
                                    const popup = CS.Controls.GetInstance(CS.Controls.Popup, $bracketDrawer, true);
                                    if (popup != null) {
                                        console.log("Closing popup because matchId is null");
                                        popup.Close();
                                    }
                                }
                            }
                        }
                        catch (error) {
                            console.error("Error while trying to trigger bracket drawer", error);
                        }
                        //   const $buttonMatchDetails2 = this.$Container.find(
                        //     "#button-match-details-2"
                        //   );
                        //   if ($buttonMatchDetails2.length) {
                        //     if (e.data.matchId) {
                        //       const buttonMatchDetailsHtml =
                        //         $buttonMatchDetails2[0] as HTMLAnchorElement;
                        //       buttonMatchDetailsHtml.href = url;
                        //       const $match = e.data.$selectedEncounter;
                        //       let $floatingButtonsContainer = $match.find(
                        //         ".floating-buttons-container"
                        //       );
                        //       if (!$floatingButtonsContainer.length) {
                        //         $match.append('<div class="floating-buttons-container"></div>');
                        //         $floatingButtonsContainer = $match.find(
                        //           ".floating-buttons-container"
                        //         );
                        //       }
                        //       $floatingButtonsContainer.append(
                        //         $buttonMatchDetails2.removeClass("hidden")
                        //       );
                        //     } else {
                        //       $buttonMatchDetails2.addClass("hidden");
                        //     }
                        //   }
                        //   const $buttonMatchStream = this.$Container.find(
                        //     "#button-match-stream"
                        //   );
                        //   if ($buttonMatchStream.length && $buttonMatchStream.length) {
                        //     if (e.data.matchId) {
                        //       const buttonMatchStreamHtml =
                        //         $buttonMatchStream[0] as HTMLAnchorElement;
                        //       buttonMatchStreamHtml.href = url + "&openstreampopup=true";
                        //       const $match = e.data.$selectedEncounter;
                        //       let $floatingButtonsContainer = $match.find(
                        //         ".floating-buttons-container"
                        //       );
                        //       if (!$floatingButtonsContainer.length) {
                        //         $match.append('<div class="floating-buttons-container"></div>');
                        //         $floatingButtonsContainer = $match.find(
                        //           ".floating-buttons-container"
                        //         );
                        //       }
                        //       $floatingButtonsContainer.append(
                        //         $buttonMatchStream.removeClass("hidden")
                        //       );
                        //     } else {
                        //       $buttonMatchStream.addClass("hidden");
                        //     }
                        //   }
                        //   const $buttonMatchWatch = this.$Container.find("#button-match-watch");
                        //   if ($buttonMatchWatch.length && $buttonMatchWatch.length) {
                        //     if (e.data.matchId) {
                        //       //je voudrais juste afficher si c'est live'
                        //       let isLive = e.data.$selectedEncounter
                        //         .find("div")
                        //         .hasClass("live");
                        //       //let isLive = true;
                        //       if (isLive) {
                        //         const buttonMatchWatchHtml =
                        //           $buttonMatchWatch[0] as HTMLAnchorElement;
                        //         buttonMatchWatchHtml.href =
                        //           url + "&highlightedsection=.accordion-videostreams";
                        //         const $match = e.data.$selectedEncounter;
                        //         $match.append($buttonMatchWatch.removeClass("hidden"));
                        //       } else {
                        //         $buttonMatchWatch.addClass("hidden");
                        //       }
                        //     } else {
                        //       $buttonMatchWatch.addClass("hidden");
                        //     }
                        //   }
                    },
                });
                CS.Controls.RRB.Events.MatchSelectionChanged({
                    selector: "#rrb-chart-main",
                    callback: (bracket, e) => {
                        if (e.data.matchId) {
                            $buttonMatchDetails.addClass("enabled");
                            var url = matchDetailsUrl.replace("matchidreplacement", e.data.matchId.toString());
                            $buttonMatchDetailsHtml.href = url;
                        }
                        else {
                            $buttonMatchDetails.removeClass("enabled");
                            $buttonMatchDetailsHtml.href = "#";
                        }
                    },
                });
            }
        }
        Views.PageContext.OnPageLoaded({ actionName: "index", controllerName: "bracket" }, (contextId) => new BracketView(contextId));
    })(Views = CS.Views || (CS.Views = {}));
})(CS || (CS = {}));

//# sourceMappingURL=bracket.js.map
